/*
 * (c) Copyright, 2008-2015 Massachusetts Institute of Technology.
 *
 *     This material may be reproduced by or for the
 *     U.S. Government pursuant to the copyright license
 *     under the clause at DFARS 252.227-7013 (June, 1995).
 */
define(['ol'], function(ol) {
		/*private String featureid;
		private String version;
		private Usersession usersession;
		private String type;
		private String strokeColor;
		private Double strokeWidth;
		private String fillColor;
		private String dashStyle;
		private Double opacity;
		private Double rotation;
		private boolean gesture = false;
		private String graphic;
		private Double graphicHeight;
		private Double graphicWidth;
		private Boolean hasGraphic;
		private Double labelsize;
		private String labelText;
		private String user;
		private String nickname;
		private String topic;
		private String time;
		private String ip;
		private long seqtime;
		private long seqnum;
		private Integer usersessionid;
		private Date lastupdate;
		private Geometry theGeom;
		private Double pointRadius;
		private String featureattributes;
		
		Types: 
		 label
		 polygon
		 
		 point
		 sketch
		 hexagon
		 circle
		*/
	

		var MapStyle = function() {
			this.defaultStyle = buildDefaultStyle();
			this.styleFunctions = [];
		};
		
		MapStyle.prototype.addStyleFunction = function(styleFunction){
			this.styleFunctions.push(styleFunction);
		};
		
		MapStyle.prototype.getStyle = function(feature, resolution, selected){
			var featureStyle = feature.get('style');
			if (featureStyle) {
				return featureStyle;
			}

			var style = null;
			var funcs = this.styleFunctions; 
			for (var i = funcs.length - 1; i >= 0; i--) {
				if (style = funcs[i](feature, resolution, selected)) {
					break;
				}
			}
			
			if (style) {
				return style;
			}
			
			return this.defaultStyle;
		};

		MapStyle.prototype.getRGBComponents = function(hexColor){
			var bigint = parseInt(hexColor.replace('#',''), 16);
			var r = (bigint >> 16) & 255;
			var g = (bigint >> 8) & 255;
			var b = bigint & 255;
			return [r, g, b];
		};
		 
	
		
		var buildDefaultStyle = function() {
			var fill = new ol.style.Fill({
				color: 'rgba(255,255,255,0.4)'
			});
			var stroke = new ol.style.Stroke({
				color: '#3399CC',
				width: 1.25
			});
			var styles = [
				new ol.style.Style({
					image: new ol.style.Circle({
						fill: fill,
						stroke: stroke,
						radius: 5
					}),
					fill: fill,
					stroke: stroke
				})
			];
			return styles;
		};
		
		return MapStyle;
	});
